import React, { useState, useContext } from "react";
import {
  Form,
  Button,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { getReportData, downloadExcel } from "services/reportService";
import "./DownloadReports.css";
import Context from "context/UserContext";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";

registerLocale("es", es);

const DownloadReports = () => {
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [tipoReporte, setTipoReporte] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [dataEncontrada, setDataEncontrada] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { token } = useContext(Context);

  const handleBuscar = async () => {
    const newErrors = {};
    if (!fechaInicio) newErrors.fechaInicio = true;
    if (!fechaFin) newErrors.fechaFin = true;
    if (!tipoReporte) newErrors.tipoReporte = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);
    const data = await getReportData(fechaInicio, fechaFin, tipoReporte, token);
    setIsLoading(false);

    if (data && data.length > 0) {
      setDataEncontrada(true);
      setMensaje("Datos encontrados");
    } else {
      setDataEncontrada(false);
      setMensaje("No se encontraron datos");
    }
  };

  const handleDescargar = async () => {
    setIsLoading(true);
    await downloadExcel(fechaInicio, fechaFin, tipoReporte, token);
    setIsLoading(false);
  };

  return (
    <Container className="download-reports">
      <Row className="justify-content-center">
        <Col md={8} className="fondo_blanco p-4">
          <h2 className="text-center titulo">Reportes</h2>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha Inicio</Form.Label>
                  <DatePicker
                    selected={fechaInicio}
                    onChange={(date) => {
                      setFechaInicio(date);
                      if (fechaFin && date > fechaFin) setFechaFin(null);
                      if (date)
                        setErrors((prev) => ({ ...prev, fechaInicio: false }));
                    }}
                    selectsStart
                    startDate={fechaInicio}
                    endDate={fechaFin}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    locale="es"
                    maxDate={new Date()}
                    minDate={new Date(2023, 0, 1)}
                    className={`form-control ${
                      errors.fechaInicio ? "is-invalid" : ""
                    }`}
                    wrapperClassName="datepicker-full-width"
                    isClearable
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  {errors.fechaInicio && (
                    <div className="invalid-feedback d-block">
                      Seleccione la fecha de inicio.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha Fin</Form.Label>
                  <DatePicker
                    selected={fechaFin}
                    onChange={(date) => {
                      setFechaFin(date);
                      if (date)
                        setErrors((prev) => ({ ...prev, fechaFin: false }));
                    }}
                    selectsEnd
                    startDate={fechaInicio}
                    endDate={fechaFin}
                    minDate={fechaInicio || new Date(2023, 0, 1)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/aaaa"
                    locale="es"
                    maxDate={new Date()}
                    className={`form-control ${
                      errors.fechaFin ? "is-invalid" : ""
                    }`}
                    wrapperClassName="datepicker-full-width"
                    isClearable
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  {errors.fechaFin && (
                    <div className="invalid-feedback d-block">
                      Seleccione la fecha de fin.
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Tipo de Reporte</Form.Label>
              <Form.Control
                as="select"
                value={tipoReporte}
                onChange={(e) => {
                  setTipoReporte(e.target.value);
                  if (e.target.value)
                    setErrors((prev) => ({ ...prev, tipoReporte: false }));
                }}
                isInvalid={errors.tipoReporte}
              >
                <option value="">Seleccione un tipo de reporte</option>
                <option value="edm-sales-all">
                  Ventas EDM (validadas y no validadas)
                </option>
                <option value="seller-ranking">Ranking de vendedores</option>
                <option value="edm-accessories">Accesorios EDM</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Seleccione un tipo de reporte.
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              variant="primary"
              onClick={handleBuscar}
              style={{ marginTop: 10 }}
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : "Buscar"}
            </Button>
          </Form>

          {mensaje && (
            <Alert
              variant={dataEncontrada ? "success" : "danger"}
              className="mt-3"
            >
              {mensaje}
            </Alert>
          )}

          {dataEncontrada && (
            <Button
              variant="success"
              onClick={handleDescargar}
              style={{ marginTop: 10 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Descargar Excel"
              )}
            </Button>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default DownloadReports;
